var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailPoiLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_943_6988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4424 52.5623H33.8877L35.8936 38.8598C36.0088 38.0742 36.4029 37.3562 37.0037 36.837C37.6045 36.3179 38.3721 36.0322 39.1661 36.0322C39.9602 36.0322 40.7277 36.3179 41.3286 36.837C41.9294 37.3562 42.3234 38.0742 42.4386 38.8598L44.4424 52.5623Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0221 32.8732C41.3984 32.8732 43.3249 30.9468 43.3249 28.5704C43.3249 26.194 41.3984 24.2676 39.0221 24.2676C36.6457 24.2676 34.7192 26.194 34.7192 28.5704C34.7192 30.9468 36.6457 32.8732 39.0221 32.8732Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9062 19.9404H5.09375V52.5561H51.9062V19.9404Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8748 38.6694L25.7198 52.5622H13.0191L11.9604 38.6562C11.9345 38.3215 11.978 37.985 12.0883 37.6679C12.1985 37.3508 12.3731 37.0599 12.6011 36.8134C12.8291 36.5669 13.1055 36.3702 13.4131 36.2356C13.7207 36.101 14.0528 36.0315 14.3885 36.0312H24.451C24.7874 36.0326 25.1199 36.1034 25.4276 36.2393C25.7353 36.3751 26.0116 36.5731 26.2392 36.8208C26.4668 37.0686 26.6407 37.3606 26.7501 37.6787C26.8594 37.9968 26.9019 38.3341 26.8748 38.6694Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.356 32.8732C21.7324 32.8732 23.6588 30.9468 23.6588 28.5704C23.6588 26.194 21.7324 24.2676 19.356 24.2676C16.9797 24.2676 15.0532 26.194 15.0532 28.5704C15.0532 30.9468 16.9797 32.8732 19.356 32.8732Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.749 9.46484V14.0739",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2578 10.4855L22.7491 4.44141L26.2381 10.4855H19.2578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.251 10.1186V5.51172",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.742 9.09863L34.2508 15.1427L30.7617 9.09863H37.742Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_943_6988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailPoiLift);
export default __webpack_public_path__ + "static/media/detail-poi-lift.b2da49d2c895e61cf9576b372ca8abb1.svg";
export { ForwardRef as ReactComponent };